export class SyncProgressEvent {
  constructor(
    // Model/service name this event refers to (matches a progressItem in the sync indicator).
    public title: string,
    // Total number of documents to sync for this service (progress-bar denominator).
    public total: number,
    // Number of documents synced so far for this service (progress-bar numerator).
    public progress: number,
    // Set on the event a service dispatches when its sync throws.
    // Currently the sync indicator only swallows this event (so the -1/-1 sentinel it carries does
    // not corrupt the progress bar) and no longer closes the whole indicator on it.
    // It is NOT rendered anywhere yet - kept intentionally so the UI could use it to flag the
    // affected service as failed in the sync indicator (e.g. show a ✗ next to its progressItem).
    public isError: boolean = false,
    // Signals that every sync service has reached a terminal state (completed, errored or cancelled)
    // and the sync indicator may now close. Dispatched once per sync run by ClientDataSyncService.
    public isAllTerminal: boolean = false
  ) {}
}
